var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325 325",
    style: {
      enableBackground: "new 0 0 325 325"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M233.733,325h5.462c1.708,0,3.335-0.728,4.474-2.002l36.096-40.387c0.983-1.1,1.526-2.523,1.526-3.998v-4.689h-47.558V325z   ",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.291,0H49.709c-3.313,0-6,2.687-6,6v313c0,3.314,2.687,6,6,6h168.024v-59.075c0-4.418,3.582-8,8-8h55.558V6   C281.291,2.687,278.604,0,275.291,0z M130.917,261.374H76.778c-4.418,0-8-3.582-8-8c0-4.418,3.582-8,8-8h54.139   c4.418,0,8,3.582,8,8C138.917,257.792,135.335,261.374,130.917,261.374z M248.222,200.795H76.778c-4.418,0-8-3.582-8-8   c0-4.418,3.582-8,8-8h171.443c4.418,0,8,3.582,8,8C256.222,197.213,252.64,200.795,248.222,200.795z M248.222,140.209H76.778   c-4.418,0-8-3.582-8-8s3.582-8,8-8h171.443c4.418,0,8,3.582,8,8S252.64,140.209,248.222,140.209z M248.222,79.625H76.778   c-4.418,0-8-3.582-8-8s3.582-8,8-8h171.443c4.418,0,8,3.582,8,8S252.64,79.625,248.222,79.625z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FDBF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.4531d484002ad66e794d74c2dfd65136.svg";
export { ForwardRef as ReactComponent };